import instance from './axios-instance'

/**
 * 获取后台报价单列表。
 * @param {Object} params 查询参数
 * @returns {Promise<Object>} 报价单分页数据
 */
export const getAdminQuotes = async (params = {}) => {
  const query = new URLSearchParams()
  query.set('page', params.page || 1)
  query.set('limit', params.limit || 10)

  if (params.keyword) query.set('keyword', params.keyword)
  if (params.status) query.set('status', params.status)
  if (params.quoteType) query.set('quoteType', params.quoteType)
  if (params.dateFrom) query.set('dateFrom', params.dateFrom)
  if (params.dateTo) query.set('dateTo', params.dateTo)

  const { data } = await instance.get(`/api/v1/admin/quotes?${query.toString()}`)
  return data
}

/**
 * 获取后台报价计算记录列表。
 * @param {Object} params 查询参数
 * @returns {Promise<Object>} 计算记录分页数据
 */
export const getAdminQuoteCalculations = async (params = {}) => {
  const query = new URLSearchParams()
  query.set('page', params.page || 1)
  query.set('limit', params.limit || 10)

  if (params.keyword) query.set('keyword', params.keyword)
  if (params.quoteType) query.set('quoteType', params.quoteType)
  if (params.dateFrom) query.set('dateFrom', params.dateFrom)
  if (params.dateTo) query.set('dateTo', params.dateTo)

  const { data } = await instance.get(`/api/v1/admin/quote-calculations?${query.toString()}`)
  return data
}

/**
 * 获取后台报价计算记录详情。
 * @param {string} id 计算记录 ID
 * @returns {Promise<Object>} 计算记录详情
 */
export const getAdminQuoteCalculationById = async (id) => {
  const { data } = await instance.get(`/api/v1/admin/quote-calculations/${id}`)
  return data?.calculation
}

/**
 * 获取后台报价单详情。
 * @param {string} id 报价单 ID
 * @returns {Promise<Object>} 报价单详情
 */
export const getAdminQuoteById = async (id) => {
  const { data } = await instance.get(`/api/v1/admin/quotes/${id}`)
  return data?.quote
}

/**
 * 更新后台报价单状态。
 * @param {{ id: string, payload: Object }} params 更新参数
 * @returns {Promise<Object>} 更新响应
 */
export const updateAdminQuoteStatus = async ({ id, payload }) => {
  const { data } = await instance.put(`/api/v1/admin/quotes/${id}/status`, payload)
  return data
}

/**
 * 后台人工调整报价价格。
 * @param {{ id: string, payload: Object }} params 更新参数
 * @returns {Promise<Object>} 更新响应
 */
export const updateAdminQuotePrice = async ({ id, payload }) => {
  const { data } = await instance.put(`/api/v1/admin/quotes/${id}/price`, payload)
  return data
}

/**
 * 下载报价附件。
 * @param {{ quoteId: string, attachmentIndex: number, fileName: string }} params 下载参数
 * @returns {Promise<void>} 无返回值
 */
export const downloadQuoteAttachment = async ({
  quoteId,
  attachmentIndex,
  fileName,
}) => {
  const { data } = await instance.get(
    `/api/v1/admin/quotes/${quoteId}/attachments/${attachmentIndex}/download`,
    { responseType: 'blob' },
  )
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName || 'quote-attachment')
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
